import { Nullable } from 'typescript-nullable';

enum PageType {
    ResultsPage = 'ResultsPage',
    VIP = 'VIP',
    Homepage = 'Homepage',
    MyMessages = 'MyMessages',
}

export function getPageType(
    pageTypeAsString: 'ResultsSearch' | 'ResultsBrowse' | 'VIP' | 'Homepage' | 'MyMessages'
): Nullable<PageType> {
    const mapping: { [index: string]: PageType } = {
        ResultsSearch: PageType.ResultsPage,
        ResultsBrowse: PageType.ResultsPage,
        VIP: PageType.VIP,
        Homepage: PageType.Homepage,
        MyMessages: PageType.MyMessages,
    };

    return mapping[pageTypeAsString];
}

export default PageType;
